import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-team-stacking/actions';

class CombinationChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setCombinationIsChecked(this.props.comboKey, isChecked));
    }

    render() {
        const {comboKey, stacking} = this.props;
        const isChecked = stacking.isCombinationChecked(comboKey);

        return (
            <label className="stack-chk">
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                {comboKey}
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(CombinationChecking);
